
const HomeworkStatusMonthlyTable = ({ data, student }) => {
    // Collect all student IDs assigned to the homework
    const allStudentIds = Array.from(
        new Set(
            data.flatMap(hw => (hw.id_student?.split(",") || []))
        )
    );

    // Map student IDs to full student objects using master student list
    const uniqueStudents = allStudentIds.map(id => {
        const match = student.find(s => s.id === +id);
        return match ? { id: match.id, name: match.name } : null;
    }).filter(Boolean);

    return (
        <div className="mt-4">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Name</th>
                        {data.map(hw => (
                            <th key={hw.id}>
                                {new Date(hw.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}<br />
                                <small>{hw.subject_name}</small><br />
                                <small>{hw.title}</small>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {uniqueStudents.map((stu) => (
                        <tr key={stu.id}>
                            <td>{stu.name}</td>
                            {data.map((hw) => {
                                const doneList = hw.done?.split(",") || [];
                                const notDoneList = hw.not_done?.split(",") || [];

                                const isDone = doneList.includes(String(stu.id));
                                const isNotDone = notDoneList.includes(String(stu.id));

                                return (
                                    <td key={hw.id} style={{ textAlign: 'center' }}>
                                        {/* {isDone ? "✅" : isNotDone ? "❌" : "-"} */}
                                        {isDone ? "Done" : isNotDone ? "❌" : "-"}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default HomeworkStatusMonthlyTable;
